module.exports = __webpack_public_path__ + "static/img/270.11be9126.png";